<div class="with-floating-button">
    <div class="content" *ngIf="(baliseDetailService.balise$ | async) as balise; else loading">
        <page-header
                [title]="baliseDetailService.isCreation ? ('admin.bibliotheque.notifications.balise.detail.title' | translate)
                    : ('admin.bibliotheque.notifications.balise.detail.titleModification' | translate : { nom: balise.nom}) "
                [listeItems]="listeTabItems"
                (onGoBack)="onGoBack()"
        ></page-header>

        <form #form="ngForm">
            <mat-card>
                <mat-card-title>
                    <span *ngIf="baliseDetailService.isCreation" [translate]="'admin.bibliotheque.notifications.balise.detail.creation'"></span>
                    <span *ngIf="!baliseDetailService.isCreation" [translate]="'admin.bibliotheque.notifications.balise.detail.modification'"></span>
                </mat-card-title>
                <mat-card-content>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="nom"
                                name="nom"
                                customType="input"
                                [lCol]="2" [rCol]="4"
                                [(ngModel)]="balise.nom"
                                libelle="admin.bibliotheque.notifications.balise.detail.nom"
                                [maxlength]="30"
                                [required]="true"
                                [postTooltip]="'admin.bibliotheque.notifications.balise.detail.nomTooltip' | translate"
                        ></custom-input>
                        <custom-input
                                ngDefaultControl
                                id="module"
                                name="module"
                                customType="select"
                                [lCol]="2" [rCol]="4"
                                [(ngModel)]="balise.idPortee"
                                libelle="admin.bibliotheque.notifications.balise.detail.module"
                                [selectOptions]="listeModuleOption"
                                optionDisplay="libelle"
                                optionValue="code"
                                [required]="true"
                        ></custom-input>
                    </div>
                    <div class="row">
                        <custom-input
                                ngDefaultControl
                                id="description"
                                name="description"
                                customType="textarea"
                                [lCol]="2" [rCol]="10"
                                [(ngModel)]="balise.description"
                                libelle="admin.bibliotheque.notifications.balise.detail.description"
                                [maxlength]="2000"
                        ></custom-input>
                    </div>
                    <div class="row">
                            <label
                                    class="col-md-2 align-self-start required"
                                    [class.has-error]="sqlField.invalid"
                                    [class.required]="!isReadOnly">
                                <span translate>admin.bibliotheque.notifications.balise.detail.requete</span>
                            </label>
                        <div class="col-md-9">
                            <!-- L'option du readonly ne marche pas d'ou l'utilisation d'une class-->
                            <ngx-codemirror
                                    #sqlField="ngModel"
                                    name="sql"
                                    [(ngModel)]="balise.requeteSQL"
                                    [options]="{
                                    theme: 'material',
                                    mode: 'text/x-mssql',
                                    lineNumbers: true,
                                    lineWrapping: true
                                }"
                                    [class.cursor-default]="isReadOnly"
                                    [required]="!isReadOnly"
                            ></ngx-codemirror>
                        </div>
                        <div class="col-md-1">
                            <mat-icon
                                    class="mb-3 align-self-center material-icons-outlined"
                                    matSuffix
                                    [nioTooltip]="'admin.bibliotheque.notifications.balise.detail.requeteTooltip' | translate"
                            >info</mat-icon>
                        </div>
                    </div>
                </mat-card-content>
            </mat-card>
        </form>
    </div>
    <floating-button [listeActions]="listeActions" [isPending]="this.baliseDetailService.isSaving"></floating-button>
</div>

<!--Affiché si on a pas encore le modèle-->
<ng-template #loading>
    <please-wait class="content"></please-wait>
</ng-template>

